export function buildMemberDataObj({
  memberFirstName,
  memberLastName,
  memberName,
  memberNumber,
  memberId,
  memberBirthDate,
  memberPhone,
  email,
  optInShareName,
  memberDisplayName,
  authenticatorEnabled,
}) {
  const initials =
    memberFirstName && memberLastName
      ? `${memberFirstName[0]}${memberLastName[0]}`
      : `${memberName ? memberName[0] : ''}`;

  return {
    memberNumber,
    id: memberId,
    displayName: memberDisplayName,
    fullName: memberName,
    firstName: memberFirstName,
    lastName: memberLastName,
    initials: initials,
    dob: memberBirthDate,
    email: email,
    photo: '',
    phone: memberPhone,
    optInShareName,
    appAuthEnabled: authenticatorEnabled,
  };
}
